// Утилита для работы с иконками ботов
// Убирает дублирование кода между UserPage.tsx и ChatMessage.tsx

import { normalizeBotName } from './botMapping';

export interface BotIcons {
  first: string;
  second: string;
  firstStyle?: React.CSSProperties;
  secondStyle?: React.CSSProperties;
}

export const getCryptoIcons = (botName: string): BotIcons => {
  const key = normalizeBotName(botName || '');
  const iconMap: { [key: string]: BotIcons } = {
    'kas': { 
      first: '/images/kaspa-kas-logo.svg', 
      second: '/images/tether-usdt-logo.svg' 
    },
    'sol': { 
      first: '/images/solana-sol-logo.svg', 
      second: '/images/tether-usdt-logo.svg' 
    },
    'bnb_usdt': { 
      first: '/images/bnb-bnb-logo.svg', 
      second: '/images/tether-usdt-logo.svg' 
    },
    'btc_usdc': { 
      first: '/images/bitcoin-btc-logo.svg', 
      second: '/images/usd-coin-usdc-logo.svg' 
    },
    'btc_usdt': {
      first: '/images/bitcoin-btc-logo.svg',
      second: '/images/tether-usdt-logo.svg',
    },
    'doge_usdt': { 
      first: '/images/dogecoin-doge-logo.svg', 
      second: '/images/tether-usdt-logo.svg' 
    },
    'eth_usdt': { 
      first: '/images/ethereum-eth-logo.svg', 
      second: '/images/tether-usdt-logo.svg', 
      firstStyle: { filter: 'brightness(2.0)' } 
    },
    'xrp_usdt': { 
      first: '/images/xrp-xrp-logo.svg', 
      second: '/images/tether-usdt-logo.svg', 
      firstStyle: { filter: 'invert(1)' } 
    },
  };

  return (
    iconMap[key] ||
    iconMap[botName] || {
      first: '/images/bitcoin-btc-logo.svg',
      second: '/images/tether-usdt-logo.svg',
    }
  );
};

// Функция для получения иконки по названию валюты
export const getCurrencyIcon = (currency: string): { src: string; style?: React.CSSProperties } => {
  const iconMap: { [key: string]: { src: string; style?: React.CSSProperties } } = {
    'kas': { src: '/images/kaspa-kas-logo.svg' },
    'sol': { src: '/images/solana-sol-logo.svg' },
    'btc': { src: '/images/bitcoin-btc-logo.svg' },
    'eth': { src: '/images/ethereum-eth-logo.svg', style: { filter: 'brightness(2.0)' } },
    'bnb': { src: '/images/bnb-bnb-logo.svg' },
    'doge': { src: '/images/dogecoin-doge-logo.svg' },
    'xrp': { src: '/images/xrp-xrp-logo.svg', style: { filter: 'invert(1)' } },
    'usdt': { src: '/images/tether-usdt-logo.svg' },
    'usdc': { src: '/images/usd-coin-usdc-logo.svg' }
  };
  
  return iconMap[currency] || { src: '/images/bitcoin-btc-logo.svg' };
}; 